import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { colorSet } from 'src/app/models/global-classes';
import { listAnimation } from '../../animations/animations';
import { ContactItem } from 'src/app/components/user-dashboard/contacts/models/contacts';

@Component({
  selector: 'app-users-symbols-group',
  templateUrl: './users-symbols-group.component.html',
  styleUrls: ['./users-symbols-group.component.css'],
  animations: [listAnimation],
})
export class UsersSymbolsGroupComponent implements OnInit {
  @Input() theRealCountIs: number;
  @Input('dummyCount') set dummyCount(count: number) {
    if (count) {
      this.usersList = this.generateDummyContacts(count);
    }
  }
  @Input() maxViewCount = 2;
  @Input() usersList: Partial<ContactItem>[] = [];
  colorSet: colorSet[] = ['primary', 'info', 'success', 'warning', 'light'];
  @Input() colorless: boolean = false;
  @Input() symbolSize: number = 35;

  @Output() onSymbolClick = new EventEmitter<Partial<ContactItem>>();
  @Output() onOthersClick = new EventEmitter<any>();
  constructor() {}

  ngOnInit() {}

  clickOnOthers() {
    this.onOthersClick.emit();
  }
  clickOnUser(user: Partial<ContactItem>) {
    this.onSymbolClick.emit(user);
  }

  generateDummyContacts(count: number): Partial<ContactItem>[] {
    const names = ['Alice', 'Bob', 'Charlie', 'Diana', 'Eve', 'Frank', 'Grace'];
    const colors = ['#f44336', '#2196f3', '#4caf50', '#ff9800', '#9c27b0'];

    return Array.from({ length: count }).map((_, index) => {
      const name = names[Math.floor(Math.random() * names.length)];
      return {
        id: Math.floor(Math.random() * 10000),
        name,
        email: `${name.toLowerCase()}${Math.floor(Math.random() * 1000)}@mail.com`,
        avatar: [
          {
            url: `https://i.pravatar.cc/100?rand=${Math.random()}`,
          },
        ], // or use initials, etc.
        color: colors[index % colors.length],
      };
    });
  }
}
